import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Box, Drawer, FormControl, IconButton, InputLabel, MenuItem, Select, Typography, useMediaQuery } from "@mui/material";
import { useContext, useState } from "react";
import { useSearchParams } from "react-router-dom";

// others
import { MENU_ITEM_HEIGHT, MENU_ITEM_PADDING_TOP, QUERY_PARAMS } from "../../constants";
import { CaseContext } from "../../context";
import { anchorOrigin, transformOrigin } from "../../theme/styleConstants";

const DepartmentFilters = () => {
  const { allLawTypes } = useContext(CaseContext)
  
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const mediumViewport = useMediaQuery("(min-width:929px)");

  const toggleDrawer = (open: boolean) => setDrawerOpen(open);

  const getFilterValues = (key: QUERY_PARAMS) => {
    const value = searchParams.get(key);
    return value ? value.split(',') : [QUERY_PARAMS.ALL];
  };

  const setParams = (key: QUERY_PARAMS, values: string[]) => {
    if (!key || values.length === 0) 
      searchParams.delete(QUERY_PARAMS.LAW_TYPES);
    else 
      searchParams.set(key, values.join(','));
    setSearchParams(searchParams);
  };

  const selectFieldWidth = mediumViewport ? "20vw" : "40vw"
  
  const FilterContent = () => (
    <Box
      flex={0.75}
      my={mediumViewport ? 0 : 3}
      gap={mediumViewport ? 2 : 5}
      display={"flex"}
      flexDirection={mediumViewport ? "row" : "column"}
      alignItems={"center"}
      justifyContent={"space-evenly"}
    >
      <Box flex={0.5} width={mediumViewport ? "auto" : "100%"}>
        <FormControl variant="outlined" sx={{ marginTop: 1.5, marginBottom: 1 }} fullWidth>
      
        <InputLabel id={`practice-label`}>Practice Areas</InputLabel>
        <Select
          fullWidth
          multiple
          label={"Practice Areas"}
          placeholder={"Practice Areas"}
          labelId="practice-label"
          displayEmpty={true}
          size="small"
          sx={{ width: selectFieldWidth, padding: 1 }}
          MenuProps={{
            ...anchorOrigin,
            ...transformOrigin,
            slotProps: {
              paper: {
                style: {
                  width: selectFieldWidth,
                  maxHeight: MENU_ITEM_HEIGHT * 4.5 + MENU_ITEM_PADDING_TOP,
                },
              },
            },
          }}
          onChange={(event) => {
            const selectedValues = event.target.value as string[];
            if (selectedValues.includes(QUERY_PARAMS.ALL)) 
              setParams(QUERY_PARAMS.LAW_TYPES, selectedValues.filter((value) => value !== QUERY_PARAMS.ALL));
            else
              setParams(QUERY_PARAMS.LAW_TYPES, selectedValues);      
            }
          }
          value={getFilterValues(QUERY_PARAMS.LAW_TYPES)}
        >
          <MenuItem sx={{ display: 'none' }} value={QUERY_PARAMS.ALL}>All</MenuItem>
            {allLawTypes?.map((lawType) => (
              <MenuItem value={lawType?.id} key={lawType?.id}>
                {`${lawType?.name || ""}`}
              </MenuItem>
            ))}
        </Select>
        </FormControl>
      </Box>
    </Box>
  )

  return (
    <Box mx={2} width={mediumViewport ? "auto" : "100%"} display={"flex"} justifyContent={mediumViewport ? "space-between" : "end"} alignItems="center">
      { mediumViewport ? 
        <FilterContent />
      :
        <>
          <IconButton title="Show filters" onClick={() =>toggleDrawer(true)} aria-label="Show filters">
              <FilterListIcon color="primary" />
          </IconButton>
          
          <Drawer anchor="right" open={drawerOpen} onClose={() => toggleDrawer(false)}>
            <Box position="relative" top={63} width={"100%"} minWidth={380} p={3}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h6">Department Filters</Typography>
              
                <IconButton onClick={() => toggleDrawer(false)}>
                  <CloseIcon />
                </IconButton>
              </Box>
            
              <FilterContent />
            </Box>
          </Drawer>
        </>
      }
    </Box>
  );
};

export default DepartmentFilters;
